import { Box, Grid, Typography, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  StyledCrossIcon,
  StyledDaysGrid,
  StyledHeadingText2,
  StyledRecurrenceGrid,
  StyledSecondaryButton,
  StyledSlotDivider,
  TopCont,
} from "../../../assets/styles/CommonStyles";

import { makeStyles } from "@mui/styles";
import Slot, { TextStyled } from "../../controls/Slot";
import { Formik } from "formik";
import { doctorSlotSchema } from "../../../utils/forms/schema.slotsSchema";
import FieldWrapper from "../../InputField/TextFieldWrapper";
import SelectionDropdown from "../../control/SelectionDropdown";
import { daysOfWeek, shiftData, slotType } from "../../../../src/constant/staticLists";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import StyledAccordion from "../../Accordion";
import { useSelector } from "react-redux";
import * as authService from "../../../services/mainService";
import moment from "moment";
import { toast } from "react-toastify";
import dayjs from "dayjs";

export const useStyles = makeStyles(() => ({
  text: {
    color: "#5E5E5E",
  },
}));

const DoctorSlotCreation = ({
  setSlotClicked,
  isSlotClicked,
  scheduleSelection,
 
}) => {
  const currentDay = new Date().getDay();
  const formattedOneYearLater = moment().add(1, "years").format("YYYY-MM-DD");
  const classes = useStyles();
  const [currencyList, setCurrencyList ] = useState([]);
  const initialDataValues = {
    currency: "",
    price: "",
    time_slots: [],
    recurrence: 0,
    day_of_week: [currentDay],
    start_date: dayjs().format("YYYY-MM-DD"),
    type: scheduleSelection,
    end_date: moment(new Date()).format("YYYY-MM-DD"),
    timezone: localStorage.getItem('timezone'),
    slot_duration: 10
  };
  const [firstShift, setFirstShift] = useState([]);
  const [secondShift, setSecondShift] = useState([]);
  const [dateError, setDateError] = useState(false);

  const { doctorAvailableTime, userData, currencieslist } = useSelector((state) => ({
    doctorAvailableTime: state.schedule.availableTimeSlotList || [],
    userData: state.auth.userData,
    currencieslist: state.public.currencies

  }));

  const handleCross = () => {
    setSlotClicked(!isSlotClicked);
  };

  const handleSubmit = async (values, { resetForm }) => {
    if (values.recurrence === 0) {
      values.start_date = dayjs().format("YYYY-MM-DD");
      values.end_date = moment(new Date()).format("YYYY-MM-DD");
      let currentDay = new Date(values.start_date).getDay();
      values.day_of_week = currentDay === 0 ? [6] : [currentDay - 1]
    }
    let data = values;
    const res = await authService.addSlotDoctorApi({ data, token: userData.token });
    if (res.response_type === "fail") {
      toast.error(res?.response?.message, {
        position: "bottom-center",
        closeButton: false,
      });
    } else {
      toast.success(res?.response?.message, { position: "bottom-center", closeButton: false, });
      handleCross();
      resetForm();
    }
  };

  useEffect(() => {
    setAvailableTime(10);
  }, []);

  const generateSlotsByDuration = (duration) => {
    const slots = [];
    let timeEnum = 1;
    const totalMinutes = 24 * 60;
    
    for (let minutes = 0; minutes < totalMinutes; minutes += duration) {
      const startTime = moment().startOf('day').add(minutes, 'minutes');
      const endTime = moment(startTime).add(duration, 'minutes').subtract(1, 'seconds');
      
      if (endTime.date() === startTime.date()) {
        slots.push({
          time_enum: timeEnum++,
          start_time: startTime.format('HH:mm:ss'),
          end_time: endTime.format('HH:mm:ss')
        });
      }
    }
    return slots;
  };

  const setAvailableTime = (duration = 10) => {
    setFirstShift([]);
    setSecondShift([]);
    const slots = generateSlotsByDuration(duration);
    
    const firstShiftSlots = [];
    const secondShiftSlots = [];
    
    slots.forEach((slot) => {
      const startMoment = moment(slot.start_time, "HH:mm:ss");
      if (startMoment.hour() < 12) {
        firstShiftSlots.push(slot);
      } else {
        secondShiftSlots.push(slot);
      }
    });
    
    setFirstShift(firstShiftSlots);
    setSecondShift(secondShiftSlots);
  };

  useEffect(async () => {
   const res = await authService.getCurrencyApi();
    if (res.response_type === "fail") {
    } else {
      const list = res?.response?.data
      list?.map((item) => {
        const temp = { label: item.name, level: item.enum };
        setCurrencyList((prev) => [...prev, temp]);
       }); 
    }
  },[]);

  return (
    <>
      <Grid container>
        <TopCont item xs={12} mt="24px">
          <StyledHeadingText2 className={classes.text}>
            Create time slots
          </StyledHeadingText2>
          <StyledCrossIcon
            src={"/assets/img/x.png"}
            alt="x"
            onClick={handleCross}
          />
        </TopCont>
        <Grid item xs={12}>
          <StyledSlotDivider />
        </Grid>
        <Grid>
        </Grid>
      </Grid>
      <div style={{ marginTop: "32px" }}>
        <Formik
          validationSchema={doctorSlotSchema}
          initialValues={initialDataValues}
          onSubmit={handleSubmit}
        >
          {({ values, handleSubmit, setFieldValue, errors, handleReset }) => {
            const handleDropdownValue = (data, fieldName) => {
              const id = data.level;
              if (fieldName === "currency") {
                setFieldValue("currency", id);
              } else {
                setFieldValue("type", id);
              }
            };
            const setSelectedItems = (slotList) => {
              setFieldValue("time_slots", slotList);
            };
            const handleRecurrence = (values, value) => {
              if (value === 6) {
                setFieldValue("day_of_week", []);
              }
              if (values.recurrence === value) {
                setFieldValue("recurrence", 0);
              } else {
                setFieldValue("recurrence", value);
              }
              if (value !== 0) {
                setFieldValue("end_date", formattedOneYearLater);
                if (value == 1) {
                  setFieldValue("day_of_week", [1, 2, 3, 4, 5, 6, 0]);
                }
              }
            };
            const daySelected = (values, day, e) => {
              if (values.day_of_week.includes(day.level)) {
                setFieldValue(
                  "day_of_week",
                  values.day_of_week.filter((d) => d !== day.level)
                );
              } else {
                setFieldValue("day_of_week", [
                  ...values.day_of_week,
                  day.level,
                ]);
              }
            };
            const handleDate = (date) => {
              let data = moment(date.$d).format("YYYY-MM-DD");
              if (moment(data).isBefore(values.start_date)) {
                toast.error("End date must be greater than or equal to start date", {
                  position: "bottom-center",
                  closeButton: false,
                });
                setDateError(true);
                return;
              }
              setDateError(false);
              setFieldValue('end_date', data);
            };

            const handleStartDate = (date) => {
              let data = dayjs(date.$d).format("YYYY-MM-DD")
              if (moment(data).isAfter(values.end_date)) {
                toast.error("Start date must be less than or equal to end date", {
                  position: "bottom-center",
                  closeButton: false,
                });
                setDateError(true);
                return;
              }
              setDateError(false);
              setFieldValue('start_date', data);
              setFieldValue('time_slots', []);
            }
            return (
              <>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4} lg={4}>
                    <SelectionDropdown
                      name="currency"
                      height={"48px"}
                      className={classes.customAutocomplete}
                      label={`Select currency type`}
                      handleDropdownValue={(data) =>
                        handleDropdownValue(data, "currency")
                      }
                      list={currencyList}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={4}>
                    <FieldWrapper
                      type="number"
                      name="price"
                      label="Enter consultation amount"
                      value={values.price}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={4}>
                    <SelectionDropdown
                      name="type"
                      height={"48px"}
                      className={classes.customAutocomplete}
                      label={`Select slot Type`}
                      handleDropdownValue={(data) =>
                        handleDropdownValue(data, "type")
                      }
                      list={slotType}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={4}>
                    <SelectionDropdown
                      name="slot_duration"
                      height={"48px"}
                      className={classes.customAutocomplete}
                      label={`Slot Duration (minutes)`}
                      value={values.slot_duration}
                      handleDropdownValue={(data) => {
                        setFieldValue("slot_duration", data.level);
                        setFieldValue('time_slots', []);
                        setAvailableTime(data.level);
                      }}
                      list={[
                        { label: "10 minutes", level: 10 },
                        { label: "15 minutes", level: 15 },
                        { label: "20 minutes", level: 20 },
                        { label: "25 minutes", level: 25 },
                        { label: "30 minutes", level: 30 },
                        { label: "35 minutes", level: 35 },
                        { label: "40 minutes", level: 40 },
                        { label: "45 minutes", level: 45 },
                        { label: "50 minutes", level: 50 },
                        { label: "55 minutes", level: 55 },
                        { label: "60 minutes", level: 60 },
                      ]}
                    />
                  </Grid>
                  <Grid item xs={12} justifyContent={"center"}>
                    <TextStyled
                      style={{ marginTop: "16px", marginBottom: "8px" }}
                    >
                      Repeat Schedule
                    </TextStyled>
                  </Grid>
                  <Grid item xs={12}>
                    <StyledRecurrenceGrid container spacing={2}>
                      <Grid onClick={() => handleRecurrence(values, 1)} className={values.recurrence == 1 ? "selected" : ""}>
                        <span name="recurrence">Daily</span>
                      </Grid>
                      <Grid onClick={() => handleRecurrence(values, 6)} className={values.recurrence == 6 ? "selected" : ""} >
                        <span name="recurrence">Custom </span>
                      </Grid>
                    </StyledRecurrenceGrid>
                  </Grid>
                 
                  {values.recurrence === 6 && (
                    <>
                      <Grid
                        item
                        xs={12}
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        <TextStyled style={{ marginTop: "16px" }}>
                          Repeat on
                        </TextStyled>
                      </Grid>
                      <StyledDaysGrid item>
                        {daysOfWeek.map((day) => (
                          <Box className={values.day_of_week.includes(day.level) ? "selected" : ''} name="day_of_week"
                            onClick={() => daySelected(values, day)}>
                            <Typography>
                              {day.label}
                            </Typography>
                          </Box>
                        ))}

                      </StyledDaysGrid>
                    </>
                  )}
                  {(values.recurrence === 1 || values.recurrence === 6) &&
                    <>
                      <Grid
                        item
                        xs={12}
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        <TextStyled>Start on</TextStyled>
                      </Grid>
                      <Grid item style={{ paddingTop: "4px" }} name="start_date">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker"]}>
                            <DatePicker disablePast value={dayjs(values.start_date)} onChange={handleStartDate} renderInput={(params) => <TextField {...params} />} />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        style={{ display: "flex", justifyContent: "left" }}
                      >
                        <TextStyled>End on</TextStyled>
                      </Grid>
                      <Grid item style={{ paddingTop: "4px" }} name="end_date">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker"]}>
                            <DatePicker disablePast value={dayjs(values.end_date)} onChange={handleDate} renderInput={(params) => <TextField {...params} />} />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Grid>
                    </>}
                  {shiftData.map((shift, index) => {
                    const isToday = dayjs(values.start_date).isSame(dayjs(), 'day');
                    const shiftList = shift.label === "First Shift" ? firstShift : secondShift;
                    
                    return (
                      <Grid item xs={12} key={index}>
                        <StyledAccordion dayName={shift.label}>
                          <Slot
                            name="time_slots"
                            list={shiftList}
                            setSelectedItems={setSelectedItems}
                            selectedItems={values.time_slots}
                            isToday={isToday}
                            startDate={values.start_date}
                          />
                        </StyledAccordion>
                      </Grid>
                    );
                  })}

                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <StyledSecondaryButton
                      disabled={Object.keys(errors).length > 0 || dateError}
                      style={{ marginBottom: 24 }}
                      onClick={() => handleSubmit()}
                    >
                      Create Slot
                    </StyledSecondaryButton>
                  </Grid>
                </Grid>
              </>
            );
          }}
        </Formik>
      </div>
    </>
  )
}

export default DoctorSlotCreation;
